import { getLocalStorageItem, setLocalStorageItem } from '../../../../utils/helpers/localStorage'

export const addOpenFolder = (folderId, localStorageKey) => {
  const folders = getOpenFolders(localStorageKey)
  folders[Number(folderId)] = true
  setLocalStorageItem(localStorageKey, folders)
}

export const removeOpenFolder = (folderId, localStorageKey) => {
  const folders = getOpenFolders(localStorageKey)
  delete folders[folderId]
  setLocalStorageItem(localStorageKey, folders)
}

export const getOpenFolders = localStorageKey => {
  return getLocalStorageItem(localStorageKey) || {}
}

export const getLocalStorageKey = entities => {
  return entities.join('_') + '_open_folders'
}
